// Digismoothie Agency Customisations

// Wrap certain product info with DIV
if ($( ".product-block__info-group" )) $( ".product-block__info-group" ).wrapAll( "<div class='product-block__wrapper info-group' />");
if ($( ".product-block__price-group" )) $( ".product-block__price-group" ).wrapAll( "<div class='product-block__wrapper price-group' />");

// Remove extra parent node from table
const tableWrapper = document.querySelector('.table-wrapper');
if (tableWrapper !== null) {
  const originalTable = tableWrapper.querySelectorAll('table');
  if (originalTable.length > 1) {
    const newTable = originalTable[originalTable.length - 1];
    tableWrapper.innerHTML = newTable.outerHTML;
  }
}
